"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import type { ReactNode } from "react"

/** A footer navigation link. Next skips the scroll-to-top when the href is
 *  the page already open, so a reader at the foot of /complete-dating-system
 *  who tapped its own footer link saw the page above him re-render while the
 *  footer stayed put (owner: "it's not actually going to the top of the
 *  page"). On the page it points at, the link scrolls to the top instead. */
export function FooterLink({ href, className, children }: { href: string; className?: string; children: ReactNode }) {
  const pathname = usePathname()
  return (
    <Link
      href={href}
      className={className}
      onClick={(event) => {
        if (pathname === href) {
          event.preventDefault()
          window.scrollTo({ top: 0, behavior: "smooth" })
        }
      }}
    >
      {children}
    </Link>
  )
}
